import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters'
import user from './modules/user'
import tabs from './modules/tabs'
import order from './modules/order'
import onlineConsultant from "./modules/onlineConsultant"
import examination from './modules/examination';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        user,
        tabs,
        order,
        onlineConsultant,
        examination
    },
    getters
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js